import React from 'react';
import { ButtonWithLoading } from '@spark/ui-components/components/Button';
import TruncatedText from '@spark/ui-components/components/TanStackTable/components/TruncatedText';

export const getFiliaisOuvidoriaColumns = ({ onEdit, onDelete } = {}) => [
  {
    id: 'nomeFilial',
    header: 'Nome da Filial',
    accessorKey: 'nomeFilial',
    size: 280,
    enableSorting: true,
    cell: ({ getValue }) => <TruncatedText value={getValue()} maxLength={80} />,
  },
  {
    id: 'dataCriacao',
    header: 'Data de Criacao',
    accessorKey: 'dataCriacaoFormatada',
    size: 180,
    enableSorting: true,
    cell: ({ getValue }) => <span>{getValue() || '-'}</span>,
  },
  ...(onEdit || onDelete
    ? [
        {
          id: 'actions',
          header: 'Acoes',
          size: 160,
          enableSorting: false,
          cell: ({ row }) => (
            <div style={{ display: 'flex', gap: '6px' }}>
              {onEdit && (
                <ButtonWithLoading
                  size="sm"
                  variant="outline-primary"
                  onClick={event => {
                    event.stopPropagation();
                    onEdit(row.original.id);
                  }}
                >
                  Editar
                </ButtonWithLoading>
              )}
              {onDelete && (
                <ButtonWithLoading
                  size="sm"
                  variant="outline-danger"
                  onClick={event => {
                    event.stopPropagation();
                    onDelete(row.original.id);
                  }}
                >
                  Excluir
                </ButtonWithLoading>
              )}
            </div>
          ),
        },
      ]
    : []),
];
